// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.middle {
  width: 100%;
  text-align: center;
}
.middle input[type=radio] {
  display: none;
}
.middle input[type=radio]:checked + .box {
  background-color: var(--primary_color);
}
.middle input[type=radio]:checked + .box span {
  color: white;
  transform: translateY(70px);
}
.middle input[type=radio]:checked + .box span:before {
  transform: translateY(0px);
  opacity: 1;
}
.middle .box {
  width: 400px;
  height: 200px;
  background-color: #fff;
  border: var(--primary_color) solid 1px;
  transition: all 250ms ease;
  will-change: transition;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  position: relative;
  font-weight: 900;
}
.middle .box:active {
  transform: translateY(10px);
}
.middle .box span {
  position: absolute;
  transform: translate(0, 60px);
  left: 0;
  right: 0;
  transition: all 300ms ease;
  font-size: 1.5em;
  -webkit-user-select: none;
          user-select: none;
  color: var(--primary_color);
}
.middle .box span:before {
  font-size: 1.2em;
  display: block;
  transform: translateY(-80px);
  opacity: 0;
  transition: all 300ms ease-in-out;
  font-weight: normal;
  color: white;
}
.middle .front-end span:before {
  font-family: FontAwesome;
  content: "\\f53d";
}
.middle .back-end span:before {
  font-family: FontAwesome;
  content: "\\f09d";
}`, "",{"version":3,"sources":["webpack://./src/pages/registration/styles/pay.scss"],"names":[],"mappings":"AAAI;EACI,WAAA;EACA,kBAAA;AACR;AACQ;EACA,aAAA;AACR;AACY;EACA,sCAAA;AACZ;AAAY;EACI,YAAA;EACA,2BAAA;AAEhB;AADgB;EACA,0BAAA;EACA,UAAA;AAGhB;AAGQ;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sCAAA;EACA,0BAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AADR;AAEQ;EACI,2BAAA;AAAZ;AAEQ;EACI,kBAAA;EACA,6BAAA;EACA,OAAA;EACA,QAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,2BAAA;AAAZ;AACY;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,UAAA;EACA,iCAAA;EACA,mBAAA;EACA,YAAA;AACZ;AAKY;EACA,wBAAA;EACA,gBAAA;AAHZ;AASY;EACA,wBAAA;EACA,gBAAA;AAPZ","sourcesContent":["    .middle {\r\n        width: 100%;\r\n        text-align: center;\r\n        \r\n        input[type=\"radio\"] {\r\n        display: none;\r\n        &:checked {\r\n            + .box {\r\n            background-color: var(--primary_color);\r\n            span {\r\n                color: white;\r\n                transform: translateY(70px);\r\n                &:before {\r\n                transform: translateY(0px);\r\n                opacity: 1;\r\n                }\r\n            }\r\n            }\r\n        }\r\n        }\r\n        .box {\r\n        width: 400px;\r\n        height: 200px;\r\n        background-color: #fff;\r\n        border: var(--primary_color) solid 1px;\r\n        transition: all 250ms ease;\r\n        will-change: transition;\r\n        display: inline-block;\r\n        text-align: center;\r\n        cursor: pointer;\r\n        position: relative;\r\n        font-weight: 900;\r\n        &:active {\r\n            transform: translateY(10px);\r\n        }\r\n        span {\r\n            position: absolute;\r\n            transform: translate(0, 60px);\r\n            left: 0;\r\n            right: 0;\r\n            transition: all 300ms ease;\r\n            font-size: 1.5em;\r\n            user-select: none;\r\n            color: var(--primary_color);\r\n            &:before {\r\n            font-size: 1.2em;\r\n            display: block;\r\n            transform: translateY(-80px);\r\n            opacity: 0;\r\n            transition: all 300ms ease-in-out;\r\n            font-weight: normal;\r\n            color: white;\r\n            }\r\n        }\r\n        }\r\n        .front-end {\r\n        span {\r\n            &:before {\r\n            font-family: FontAwesome;\r\n            content: \"\\f53d\";\r\n            }\r\n        }\r\n        }\r\n        .back-end {\r\n        span {\r\n            &:before {\r\n            font-family: FontAwesome;\r\n            content: \"\\f09d\";\r\n            }\r\n        }\r\n        }\r\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
